import Vue from 'vue'
import Vuex from 'vuex'

import AuthModule from './auth_module'
import BankModule from './lmg_bank_module'
import BillingModule from './lmg_billing_module'
import BranchModule from './lmg_branch_module'
import CommModule from './lmg_comm_module'
import InsuranceModule from './lmg_insurance_module'
import PaymentModule from './lmg_payment_module'
import PersonModule from './lmg_person_module'
import TransactionModule from './lmg_trans_module'
import TtypeModule from './lmg_ttype_module'
import UserModule from './lmg_user_module'
import CustomerModule from './lmg_customer_module'
import InvoiceModule from './lmg_invoice_module'
import AddressModule from './lmg_address_module'


import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

const modules = {
    Auth: AuthModule,
    Bank: BankModule,
    Billing: BillingModule,
    Branch: BranchModule,
    Comm: CommModule,
    Insure: InsuranceModule,
    Payment: PaymentModule,
    Person: PersonModule,
    Transaction: TransactionModule,
    Ttype: TtypeModule,
    User: UserModule,
    Customer: CustomerModule,
    Invoice: InvoiceModule,
    Address: AddressModule,
}

export default new Vuex.Store({
  modules,
  plugins: [createPersistedState({
	paths: ['Auth'],
  })]
})
